import { IPromise, IQService, IServiceProvider } from "angular";
import { ChangeJournalObjectIdentifier, ChangeJournalObject } from "../models";
import {
  ChangeJournalViewItemService,
  ChangeJournalViewItemServiceComponentConfig,
  ChangeJournalViewItemServiceComponentConfigObject,
} from "./service";

export interface ChangeJournalObjectContainerEntry {
  id: ChangeJournalObjectIdentifier;
  promise: IPromise<ChangeJournalObject>;
}

export class ChangeJournalViewItemServiceProvider implements IServiceProvider {
  private typeComponents: ChangeJournalViewItemServiceComponentConfigObject =
    {};

  addTypeComponent(
    name: string,
    config: ChangeJournalViewItemServiceComponentConfig
  ) {
    this.typeComponents[name] = config;
  }

  $get = [
    "$q",
    "$injector",
    ($q: IQService, $injector: angular.auto.IInjectorService) => {
      const configs = Object.entries(this.typeComponents).reduce(
        (result, next) => {
          result[next[0].toLowerCase()] = <
            ChangeJournalViewItemServiceComponentConfig
          >next[1];
          return result;
        },
        <ChangeJournalViewItemServiceComponentConfigObject>{}
      );

      return new ChangeJournalViewItemService(configs, $q, $injector);
    },
  ];
}
